import React, { createContext, useContext, useState, useCallback } from 'react';
import { X } from 'lucide-react';

/* ---------- Toasts ---------- */
const ToastCtx = createContext(null);
export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);
  const show = useCallback((msg, type = 'ok') => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3200);
  }, []);
  return (
    <ToastCtx.Provider value={show}>
      {children}
      {toast && <div className={`toast ${toast.type === 'err' ? 'err' : ''}`}>{toast.msg}</div>}
    </ToastCtx.Provider>
  );
}
export const useToast = () => useContext(ToastCtx) || (() => {});

/* ---------- Modal ---------- */
export function Modal({ title, onClose, children, footer, large }) {
  return (
    <div className="modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={`modal ${large ? 'modal-lg' : ''}`}>
        <div className="modal-head">
          <h3>{title}</h3>
          <button className="icon-btn" onClick={onClose} aria-label="Schließen"><X size={20} /></button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-foot">{footer}</div>}
      </div>
    </div>
  );
}

/* ---------- Spinner ---------- */
export function PageLoading() {
  return <div className="loading-screen"><div className="loading-spinner" /></div>;
}

/* ---------- Status ---------- */
export const STATUS_LABEL = {
  draft: 'Entwurf', planned: 'Geplant', assigned: 'Eingeteilt', completed: 'Abgeschlossen', cancelled: 'Storniert',
};
export function StatusPill({ status }) {
  return <span className={`status status-${status || 'draft'}`}>{STATUS_LABEL[status] || status}</span>;
}

export const ROLE_LABEL = { GF: 'Wachführer (GF)', Ma: 'Maschinist (Ma)', CREW: 'Mannschaft' };

export function Confirm({ text, onConfirm, onClose, danger = true, confirmLabel = 'Löschen' }) {
  return (
    <Modal title="Bestätigen" onClose={onClose}
      footer={<>
        <button className="btn btn-secondary" onClick={onClose}>Abbrechen</button>
        <button className={`btn ${danger ? 'btn-primary' : 'btn-primary'}`} onClick={() => { onConfirm(); onClose(); }}>{confirmLabel}</button>
      </>}>
      <p>{text}</p>
    </Modal>
  );
}
